import { performCmdbGetRequest } from '@atlassian/jira-servicedesk-cmdb-client/src/fetch.tsx';
import { getCmdbConfigStatusTypeUrl } from '@atlassian/jira-servicedesk-cmdb-rest-urls/src/common/constants/config.tsx';

import type {
	WorkspaceId,
	SchemaId,
} from '@atlassian/jira-servicedesk-insight-shared-types/src/common/types/shared-types/index.tsx';

import type { CmdbNumericStatusCategory } from '@atlassian/jira-servicedesk-insight-shared-types/src/common/types/status.tsx';

export type StatusTypeResponse = {
	id: string;
	name: string;
	category: CmdbNumericStatusCategory;
	objectSchemaId?: SchemaId;
	description?: string;
};

export const fetchSchemaStatusTypes = async ({
	workspaceId,
	schemaId,
	controller,
}: {
	workspaceId: WorkspaceId;
	schemaId: SchemaId;
	controller?: AbortController;
}): Promise<StatusTypeResponse[]> => {
	const globalStatusesPromise: Promise<StatusTypeResponse[]> = performCmdbGetRequest(
		getCmdbConfigStatusTypeUrl(workspaceId),
		controller ? { signal: controller.signal } : undefined,
	);
	const schemaStatusesPromise: Promise<StatusTypeResponse[]> = performCmdbGetRequest(
		getCmdbConfigStatusTypeUrl(workspaceId, {
			objectSchemaId: schemaId,
		}),
		controller ? { signal: controller.signal } : undefined,
	);
	return [...(await globalStatusesPromise), ...(await schemaStatusesPromise)];
};
